import { NgModule } from '@angular/core';
import { AitAuthFormComponent } from './auth-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AitButtonModule } from '@aitarget/button';
import { AitInputTextModule } from '@aitarget/input-text';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, AngularSvgIconModule, AitButtonModule, AitInputTextModule],
  declarations: [AitAuthFormComponent],
  exports: [AitAuthFormComponent]
})
export class AitAuthFormModule {}
